/**
 * People Master seed — villagers (UI mock).
 */

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'T', label: 'Transgender' },
];

export const GENDER_LABELS = {
  M: 'Male',
  F: 'Female',
  T: 'Transgender',
};

export function formatGender(code) {
  if (!code) return '—';
  return GENDER_LABELS[code] || code;
}

export const VERIFICATION_STATUSES = ['Verified', 'Pending', 'Rejected'];

export const VERIFICATION_OPTIONS = VERIFICATION_STATUSES.map((s) => ({
  value: s,
  label: s,
}));

export const EDUCATION_OPTIONS = [
  '<10',
  '10',
  '12',
  'Graduation',
  'Post Graduation',
];

export const peopleMasterSeed = [
  {
    peopleId: 'P-001',
    name: 'Ramesh',
    fatherHusbandName: 'Karsan',
    surname: 'Patel',
    fullName: 'Ramesh Karsan Patel',
    mobile: '9876543210',
    email: 'ramesh.patel@example.com',
    aadhaar: 'XXXX-XXXX-1234',
    pan: 'ABCDE1234F',
    electionCard: '',
    drivingLicense: 'GJ12 20200001234',
    dob: '1985-06-15',
    gender: 'M',
    address1: 'Near Gram Panchayat',
    address2: '',
    villageId: 'V-MUN-003',
    pin: '370421',
    education: '10',
    educationDetails: '',
    photo: null,
    verificationStatus: 'Verified',
    active: true,
  },
  {
    peopleId: 'P-002',
    name: 'Meena',
    fatherHusbandName: 'Bhima',
    surname: 'Jadeja',
    fullName: 'Meena Bhima Jadeja',
    mobile: '9876501122',
    email: '',
    aadhaar: 'XXXX-XXXX-5678',
    pan: '',
    electionCard: 'ABC1234567',
    drivingLicense: '',
    dob: '1992-03-22',
    gender: 'F',
    address1: 'Main Road',
    address2: 'Opp. Temple',
    villageId: 'V-MUN-010',
    pin: '370421',
    education: '12',
    educationDetails: 'Arts',
    photo: null,
    verificationStatus: 'Verified',
    active: true,
  },
  {
    peopleId: 'P-003',
    name: 'Suresh',
    fatherHusbandName: 'Laxman',
    surname: 'Gadhvi',
    fullName: 'Suresh Laxman Gadhvi',
    mobile: '9825098765',
    email: 'suresh.g@example.com',
    aadhaar: '',
    pan: '',
    electionCard: '',
    drivingLicense: 'GJ12 20180004567',
    dob: '1978-11-08',
    gender: 'M',
    address1: 'Port belt area',
    address2: '',
    villageId: 'V-MUN-001',
    pin: '370421',
    education: 'Graduation',
    educationDetails: 'B.Com',
    photo: null,
    verificationStatus: 'Pending',
    active: true,
  },
  {
    peopleId: 'P-004',
    name: 'Kiran',
    fatherHusbandName: 'Danabhai',
    surname: 'Rabari',
    fullName: 'Kiran Danabhai Rabari',
    mobile: '9909911223',
    email: '',
    aadhaar: 'XXXX-XXXX-9012',
    pan: '',
    electionCard: '',
    drivingLicense: '',
    dob: '1998-01-30',
    gender: 'M',
    address1: '',
    address2: '',
    villageId: 'V-MUN-012',
    pin: '370421',
    education: '<10',
    educationDetails: '',
    photo: null,
    verificationStatus: 'Rejected',
    rejectionReason: 'Incomplete KYC documents and address mismatch with Aadhaar.',
    active: false,
  },
];
